import React from 'react';
import { Box } from '@mui/material';

const Filler: React.FC<{ amount?: number }> = ({ amount = 1 }) => (
  <Box sx={{ flex: amount }} />
);

export default Filler;
